/**
 * Liga o modal de decisão do saldo ao período vigente.
 *
 * Fica no layout para que a pergunta apareça em qualquer tela da área logada,
 * e não apenas se o usuário passar pela tela financeira — a virada de PO pode
 * acontecer com ele em qualquer lugar do produto.
 *
 * Usa o PO VIGENTE, não o selecionado. `useCurrentBudgetPeriod` devolve o
 * período que o usuário está navegando, que pode ser um PO futuro ainda
 * pendente — e o modal, sendo não-dispensável, prenderia a tela sobre um
 * período que ele só estava visitando.
 *
 * O modal é mantido sem acesso a hooks de período de propósito: assim ele
 * continua sendo um componente de apresentação, testável isoladamente.
 */
import { useActiveBudgetPeriod } from '@/hooks/use-financial';

import { CarryoverDecisionModal } from './CarryoverDecisionModal';

export function CarryoverDecisionGate() {
  const { data: period } = useActiveBudgetPeriod();

  if (!period?.id) return null;

  return <CarryoverDecisionModal periodId={period.id} />;
}
